// ABOUTME: Reset password form content for setting a new password via reset code.
// ABOUTME: Renders inside AuthLayout which provides the shared shell (logo, controls, OnTheRight).
import { Box, IconButton, InputBase, Typography, useTheme } from "@mui/material";
import { Formik} from "formik";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import Shbutton from "../../components/theme/buttons/Shbutton";

import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LockIcon from '@mui/icons-material/Lock';

import { tokens } from "../../theme";
import Text from "../../components/theme/text/Text";
import cx from 'classnames';
import { useTranslation } from "react-i18next";
import { Warning } from "@mui/icons-material";
import { useResetPasswordMutation, useVerifyResetCodeMutation } from "../../newapi/user/passwordresetSlice";
// import { login } from "../../api/global/user";
// import { useAuth } from "../../authentication/AuthState";
const initialValues = {
    password: "",
    passwordAgain: "",
}

const userSchema = yup.object().shape({
    password: yup.string().required("required"),
    passwordAgain: yup.string().required("required"),
    // passwordAgain: yup.string()
    //    .oneOf([yup.ref('password'), null], 'Passwords must match')
    //    .required('Password confirmation is required'),
});

const ResetPassword = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const {t} = useTranslation();
    const [errorMessage, setErrorMessage] = useState("");
    const [errorDetails, setErrorDetails] = useState([]);
    const navigate = useNavigate();
    const [passwordType, setPasswordType] = useState("password");
    const [resetCodeData, setResetCodeData] = useState({});

    const { isOnline, brand, brandSlug } = useOutletContext();

    useEffect(() => {
        async function fetchData() {
        const queryParams = new URLSearchParams(window.location.search);
        const resetCode = queryParams.get('code');
        if(!resetCode){
            navigate("/login");
            return;
        }
        if(resetCode){
            const result = await verifyResetCode(resetCode);
            setResetCodeData(result.data);
        }
        }
        fetchData();
    },[]);



    // useLoginMutation
    const [ResetPasswordMut, { isSuccess, isLoading,isUninitialized, isError,error }] = useResetPasswordMutation();
    const [verifyResetCode, { isSuccess: isSuccessVerify, isLoading: isLoadingVerify,isUninitialized: isUninitializedVerify, isError: isErrorVerify,error: errorVerify }] = useVerifyResetCodeMutation();

    const handleFormSubmit = async (values) => {
        setErrorMessage("");
        setErrorDetails([]);

        let resetVals = {
            passwordAgain: values.passwordAgain,
            password: values.password,
            code: resetCodeData.code,
            email: resetCodeData.email,
        };

        if(resetVals.password !== resetVals.passwordAgain){
            setErrorMessage(t("passwords_do_not_match"));
            return;
        }
        if(resetVals.password.length < 8){
            setErrorMessage(t("password_too_short"));
            return;
        }


        try {
            const res = await ResetPasswordMut(resetVals);
            if(res.error) {
                const type = res.error?.data?.type;
                const errors = res.error?.data?.errors;
                setErrorMessage(type ? t(type) : t("invalid_reset_code"));
                setErrorDetails(Array.isArray(errors) ? errors : []);
                return;
            }
            if(res.data.status === 200){
                navigate("/login");
            }
        } catch (error) {
            navigate("/login");
        }

    }

    useEffect(() => {
        if(isError) {
            const type = error?.data?.type;
            const errors = error?.data?.errors;
            setErrorMessage(type ? t(type) : t("invalid_reset_code"));
            setErrorDetails(Array.isArray(errors) ? errors : []);
            return;
        }


        if(isSuccess) {
           //Do we log them in? idk

            // navigate("/warehouse/stock");
        }
    },[isSuccess, isError]);

    useEffect(() => {
        if(!isUninitializedVerify && !isLoadingVerify){
            if(isErrorVerify){
                navigate("/login");
            }

        }
    },[isErrorVerify]);



    return (
        <Box
            sx={{
                padding: "32px",
                borderRadius: "24px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                paddingTop:"40px",
                "@media screen and (max-width: 47.9375em)": {
                    p:0,
                    px:3,
                }
            }}
        >
            <Typography variant="h1" fontWeight="1000" fontFamily="Roboto, sans-serif"
                sx={{
                    color:colors.txt['primary'],
                    textOverflow:"ellipsis",
                    whiteSpace:"nowrap",
                    overflow:"hidden",
                    fontSize:"32px",
                    "@media screen and (max-width: 47.9375em)" : {
                        fontSize:21
                    }
                }}
            >
                {t("set_new_password")}
            </Typography>
            <Typography variant="p" fontWeight="400" fontFamily="Roboto, sans-serif"
                sx={{
                    color:colors.txt['secondary'],
                    textOverflow:"ellipsis",
                    whiteSpace:"nowrap",
                    overflow:"hidden",
                    fontSize:"17px",
                    marginBottom:4,
                    "@media screen and (max-width: 47.9375em)" : {
                        fontSize:14,
                        marginBottom:3,
                    }
                }}
            >
                {t("set_new_password_description")}
            </Typography>
            <Box
                sx={{
                    "@media screen and (max-width: 47.9375em)" : {
                        width:1,
                    }
                }}
            >
                {errorMessage && (<Box
                                display="flex"
                                sx={{
                                    width:"450px",
                                    borderRadius:6,
                                    display:"flex",
                                    alignItems:"center",
                                    marginBottom:2,
                                    background:colors.red[300],
                                    border:`1px solid ${colors.red[400]}`,
                                    minHeight:64,
                                    py:1.5,
                                    pl:2,
                                    pr:2,
                                    color:"white",
                                    "@media screen and (max-width: 64em)" : {
                                        minHeight:40,
                                        borderRadius:5,
                                        px:1,
                                    },
                                    "@media screen and (max-width: 47.9375em)" : {
                                        width:1,
                                    }

                                }}

                            >
                                <Box
                                    sx={{
                                        height:32,
                                        width:32,
                                        minWidth:32,
                                        textAlign:"center",
                                        background: theme.palette.mode === "dark" ? colors.grey[500] : colors.white[300],
                                        color: colors.red[400],
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        borderRadius:16,
                                        mr:2,
                                    }}
                                >
                                    <Warning
                                    fontSize="small"
                                        // color={!!touched.email && !!errors.email ? "red" : "primaryGrey"}

                                    />

                                </Box>

                                <Box >
                                    <Text sx={{color:"white"}} >{errorMessage}</Text>
                                    {errorDetails.length > 0 && (
                                        <Box component="ul" sx={{m:0, pl:2, mt:0.5}}>
                                            {errorDetails.map((err, index) => (
                                                <Box component="li" key={index} sx={{fontSize:13, color:"white"}}>
                                                    {t(err)}
                                                </Box>
                                            ))}
                                        </Box>
                                    )}
                                </Box>

                            </Box>)}
                <Formik
                    onSubmit={handleFormSubmit}
                    initialValues={initialValues}
                    validationSchema={userSchema}>
                    {({values, errors, touched, handleBlur, handleChange, handleSubmit}) => (
                        <form className="login-form" onSubmit={handleSubmit}>
                            <Box
                                display="flex"
                                sx={{
                                    width:"450px",
                                    borderRadius:8,
                                    display:"flex",
                                    alignItems:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[600] : colors.grey[0],
                                    boxShadow: theme.palette.mode === "dark" ? null : "0px 2px 4px rgba(49,65,95,.15)",
                                    border: theme.palette.mode === "dark" ? null : `1px solid ${colors.grey[100]}`,
                                    height:64,
                                    pl:2,
                                    pr:2,
                                    "&.error": {
                                        background:colors.red[100],
                                        border: `1px solid ${colors.red[400]}`,
                                        color: colors.red[400]
                                    },
                                    "input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active" : {
                                        backgroundClip:colors.txt['primary'],
                                        "webkit-text-fill-color":colors.txt['primary'],
                                        transition: "background-color 5000s ease-in-out 0s",
                                        boxShadow:`inset 0 0 20px 20px ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                                        WebkitTextFillColor: colors.txt['primary'],
                                        fontSize:16
                                    },
                                    "@media screen and (max-width: 64em)" : {
                                        height:48,
                                        borderRadius:6,
                                        px:1,
                                    },
                                    "@media screen and (max-width: 47.9375em)" : {
                                        width:1,
                                    }
                                }}

                                className={cx({
                                    'error': !!touched.email && !!errors.email
                                })}
                            >
                                <Box
                                    sx={{
                                        height:32,
                                        width:32,
                                        textAlign:"center",
                                        background: theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100],
                                        color: theme.palette.mode === "dark" ? colors.blue[400] :colors.primary[400],
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                        borderRadius:16,
                                        mr:2,
                                    }}
                                >
                                    <MailOutlineIcon
                                    fontSize="small"
                                        // color={!!touched.email && !!errors.email ? "red" : "primaryGrey"}

                                    />

                                </Box>

                                <Box 
                                    sx={{
                                        display:"flex",
                                        flexDirection:"column",
                                    }}
                                >
                                    <Text bold >{resetCodeData?.name}</Text>
                                    <Text light>{resetCodeData?.email}</Text>
                                </Box>

                            </Box>


                            <Box
                                sx={{
                                    width:"450px",
                                    marginTop:2,
                                    width:"450px",
                                    borderRadius:6,
                                    display:"flex",
                                    alignItems:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                    border:theme.palette.mode === "dark" ? null : "1px solid rgba(255,255,255,.15)",
                                    height:48,
                                    px:2,
                                    "&.error": {
                                        background:colors.red[100],
                                        border: `1px solid ${colors.red[400]}`,
                                        color: colors.red[400]
                                    },
                                    "input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active" : {
                                        backgroundClip:colors.txt['primary'],
                                        "webkit-text-fill-color":colors.txt['primary'],
                                        transition: "background-color 5000s ease-in-out 0s",
                                        boxShadow:`inset 0 0 20px 20px ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                                        WebkitTextFillColor: colors.txt['primary'],
                                        fontSize:16
                                    },
                                    "@media screen and (max-width: 64em)" : {
                                        height:40,
                                        borderRadius:5,
                                        px:1,
                                    },
                                    "@media screen and (max-width: 47.9375em)" : {
                                        width:1,
                                        marginTop:1.5,
                                    }
                                }}

                                className={cx({
                                    'error': !!touched.password && !!errors.password
                                })}
                            >
                                <Box
                                    sx={{
                                        height:32,
                                        width:32,
                                        textAlign:"center",
                                        color: colors.txt['secondary'],
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                    }}
                                >
                                    <LockIcon
                                        // color={!!touched.password && !!errors.password ? "red" : "primaryGrey"}

                                    />


                                </Box>
                                <InputBase
                                    name="password"
                                    type={passwordType}
                                    sx={{
                                        pl:1.5,
                                        flex:1,
                                        color:colors.txt['primary'],
                                        fontSize:16
                                    }}
                                    placeholder={t("password") }
                                    value={values.password}
                                    onBlur={handleBlur}
                                    onChange={(e, event) => {
                                        handleChange({ ...event, target: { name: 'password', value: e.target.value } })
                                    }}
                                    // onChange={(e) => console.log(e.target.value)}
                                    // error={!!touched.password && !!errors.password}

                                    />
                                    <IconButton
                                        tabIndex={-1}
                                        type="button"
                                        sx={{
                                            p: 1,
                                            color:colors.txt['primary']
                                        }}
                                        onClick={() => setPasswordType((prev) => (prev === "password" ? "text" : "password"))}
                                    >
                                        {passwordType === 'password' ? (
                                            // <DarkModeOutlinedIcon />
                                            <VisibilityIcon/>
                                        ) : (
                                            // <LightModeOutlinedIcon />
                                            <VisibilityOffIcon />
                                        )}
                                        {/* <PersonOutlineIcon color={!!touched.password && !!errors.password ? "red" : "primaryGrey"} /> */}
                                    </IconButton>
                            </Box>

                            <Box
                                sx={{
                                    width:"450px",
                                    marginTop:2,
                                    width:"450px",
                                    borderRadius:6,
                                    display:"flex",
                                    alignItems:"center",
                                    background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                    border:theme.palette.mode === "dark" ? null : "1px solid rgba(255,255,255,.15)",
                                    height:48,
                                    px:2,
                                    "&.error": {
                                        background:colors.red[100],
                                        border: `1px solid ${colors.red[400]}`,
                                        color: colors.red[400]
                                    },
                                    "input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus,input:-webkit-autofill:active" : {
                                        backgroundClip:colors.txt['primary'],
                                        "webkit-text-fill-color":colors.txt['primary'],
                                        transition: "background-color 5000s ease-in-out 0s",
                                        boxShadow:`inset 0 0 20px 20px ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                                        WebkitTextFillColor: colors.txt['primary'],
                                        fontSize:16
                                    },
                                    "@media screen and (max-width: 64em)" : {
                                        height:40,
                                        borderRadius:5,
                                        px:1,
                                    },
                                    "@media screen and (max-width: 47.9375em)" : {
                                        width:1,
                                        marginTop:1.5,
                                    }
                                }}

                                className={cx({
                                    'error': !!touched.passwordAgain && !!errors.passwordAgain
                                })}
                            >
                                <Box
                                    sx={{
                                        height:32,
                                        width:32,
                                        textAlign:"center",
                                        color: colors.txt['secondary'],
                                        display:"flex",
                                        alignItems:"center",
                                        justifyContent:"center",
                                    }}
                                >
                                    <LockIcon
                                        // color={!!touched.password && !!errors.password ? "red" : "primaryGrey"}

                                    />

                                </Box>
                                <InputBase
                                    name="passwordAgain"
                                    type={passwordType}
                                    sx={{
                                        pl:1.5,
                                        flex:1,
                                        color:colors.txt['primary'],
                                        fontSize:16
                                    }}
                                    placeholder={t("password_again") }
                                    value={values.passwordAgain}
                                    onBlur={handleBlur}
                                    onChange={(e, event) => {
                                        handleChange({ ...event, target: { name: 'passwordAgain', value: e.target.value } })
                                    }}
                                    // onChange={(e) => console.log(e.target.value)}
                                    // error={!!touched.password && !!errors.password}

                                />
                                    <IconButton
                                        tabIndex={-1}
                                        type="button"
                                        sx={{
                                            p: 1,
                                            color:colors.txt['primary']
                                        }}
                                        onClick={() => setPasswordType((prev) => (prev === "password" ? "text" : "password"))}
                                    >
                                        {passwordType === 'password' ? (
                                            // <DarkModeOutlinedIcon />
                                            <VisibilityIcon/>
                                        ) : (
                                            // <LightModeOutlinedIcon />
                                            <VisibilityOffIcon />
                                        )}
                                        {/* <PersonOutlineIcon color={!!touched.password && !!errors.password ? "red" : "primaryGrey"} /> */}
                                    </IconButton>
                            </Box>

                            {/* <TextField
                            fullWidth
                            variant="filled"
                            type="password"
                            label="Wachtwoord"
                            onBlur={handleBlur}
                            onChange={handleChange}
                            value={values.password}
                            name="password"
                            error={!!touched.password && !!errors.password}
                            helperText={touched.password && errors.password}
                            /> */}
                            <Box

                                sx={{
                                    display:"flex",
                                    justifyContent:"flex-end",
                                    marginTop:2,
                                    width:1,

                                }}
                            >
                                <Shbutton type="submit" disabled={!isOnline} block color={isOnline ? theme.palette.mode === "dark" ? "blue" : "primary" : "red"} variant="contained"
                                    sx={isOnline && brand?.color?.button ? {
                                        backgroundColor: `${theme.palette.mode === "dark" ? brand.color.button.dark : brand.color.button.light} !important`,
                                        color: `${theme.palette.mode === "dark" ? brand.color.button.contrastDark : brand.color.button.contrastLight} !important`,
                                        "&:hover": { backgroundColor: `${theme.palette.mode === "dark" ? brand.color.button.dark : brand.color.button.light} !important` },
                                    } : {}}
                                >
                                    {t("confirm")}
                                </Shbutton>
                                {/* <Button type="submit" color="primary" variant="contained">
                                    Create new user
                                </Button> */}
                            </Box>
                            <Box

                                sx={{
                                    display:"flex",
                                    justifyContent:"flex-end",
                                    marginTop:2,
                                    width:1,

                                }}
                            >
                                <Shbutton link={brandSlug ? `/login/${brandSlug}` : "/login"} disabled={!isOnline} block color={theme.palette.mode === "dark" ? "primaryGreyOpposite" : "primaryGrey"} variant="text">
                                    {t("back_to_login")}
                                </Shbutton>
                            </Box>
                        </form>
                    )}
                </Formik>
            </Box>
        </Box>
    )
}

export default ResetPassword;
